import { Button } from "antd";
import { RiFileEditLine } from "react-icons/ri";
import { productionStore } from "src/stores/production-store";
import { componentPalette } from "src/theme/component-palette";

const EditProduction = () => {
  const statusEditProductionModal = productionStore((state) => state.statusEditProductionModal);
  const setStatusEditProductionModal = productionStore((state) => state.setStatusEditProductionModal);

  const onClickEdit = () => {
    if (setStatusEditProductionModal) {
      if (statusEditProductionModal === "inprogress") {
        // กดครั้งที่สอง - เป็นการ save และแสดง Modal confirm
        setStatusEditProductionModal("confirmed");
      } else if (statusEditProductionModal === "closed" || !statusEditProductionModal) {
        // กดครั้งแรก - เปิดโหมด edit
        setStatusEditProductionModal("open");
      }
    }
  };

  return (
    <div>
      <Button
        type="text"
        disabled={statusEditProductionModal === "loading" || statusEditProductionModal === "confirmed"}
        icon={
          <RiFileEditLine
            size={26}
            color={
              statusEditProductionModal === "open" || statusEditProductionModal === "inprogress" ? componentPalette.primary : "#9D9C9B"
            }
          />
        }
        onClick={onClickEdit}
      />
    </div>
  );
};

export default EditProduction;
